import { useQuery, gql } from '@apollo/client';

export const appContextQuery = gql`
    query AppContext {
        security {
            entry {
                field {
                    iD1 {
                        canView
                    }
                    iD2 {
                        canView
                    }
                    iD3 {
                        canView
                    }
                    iD4 {
                        canView
                    }
                    iD5 {
                        canView
                    }
                }
                filter {
                    allEntries {
                        canView
                    }
                    activeEntries {
                        canView
                    }
                }
            }
        }

        global {
            setting {
                iD1Label
                iD2Label
                iD3Label
                iD4Label
                iD5Label
            }
        }
    }
`;

export interface IAppContextQueryResult {
    security: {
        entry: {
            field: {
                iD1: {
                    canView: boolean;
                };
                iD2: {
                    canView: boolean;
                };
                iD3: {
                    canView: boolean;
                };
                iD4: {
                    canView: boolean;
                };
                iD5: {
                    canView: boolean;
                };
            };
            filter: {
                allEntries: {
                    canView: boolean;
                };
                activeEntries: {
                    canView: boolean;
                };
            };
        };
    };

    global: {
        setting: {
            iD1Label: string;
            iD2Label: string;
            iD3Label: string;
            iD4Label: string;
            iD5Label: string;
        };
    };
}

export const useAppContextQuery = () => useQuery<IAppContextQueryResult>(appContextQuery);
